module.exports = __webpack_public_path__ + "static/media/close_circle_black.879a16f6.svg";